import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ToastDialog from "../dialogs/ToastDialog/toast";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import BottomNavbar from "../other-components/BottomNavbar/Navbar";
import { getStorage, setStorage } from "../modals/Storage";
import { API_ACCESS_URL, copyText, generateReferalURL } from "../modals/Constants";

import styles from "../css/Screens.module.css";
import general from "../css/General.module.css";

function Referal() {
  const navigate = useNavigate();
  const toastDialogRef = useRef(null);
  const [isLoadingShow, setLoadingShow] = useState(false);

  const [pageConst, setConstants] = useState({
    accountBalance: 0,
    totalInvited: 0,
    totalIncome: 0,

    toastDialogShow: false,
    toastMessage: "",
    recordList: [],
  });

  // toast component
  const onToastChange = (data, msg) => { };

  const showToast = (message, duration, delay, mode) => {
    toastDialogRef.current.openDialog(message, duration, delay, mode);
  }

  function getReferalRecords() {
    const fecthApiData = async (url, formData) => {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Route: "route-referal-records",
            AuthToken: getStorage("secret"),
          },
          body: JSON.stringify(formData),
        });
        const data = await res.json();
        setLoadingShow(false);

        if (data.status_code == "success") {
          setConstants({
            ...pageConst,
            totalInvited: data.total_invited,
            totalIncome: data.total_income
          });

        } else if (data.status_code == "authorization_error") {
          // signOutAccount();
        }
      } catch (error) {
        setLoadingShow(false);
      }
    };

    if (!isLoadingShow) {
      setLoadingShow(true);

      const formData = {
        ACCOUNT_ID: getStorage("uid")
      };
      fecthApiData(API_ACCESS_URL, formData);
    }
  }

  const copyMyId = () => {
    copyText(getStorage("uid"));
    showToast("ID Copied!", 2500, 0, 1);
  };

  const copyInviteCode = () => {
    copyText(generateReferalURL(getStorage("uid")));
    showToast("Invite URL Copied!", 2500, 0, 1);
  };

  useEffect(() => {
    if (!getStorage("uid")) {
      navigate("/login", { replace: true });
    } else {
      getReferalRecords();
    }
  }, []);

  return (
    <div className={[general.appContents].join(" ")}>
      <LoadingDialog intentData={isLoadingShow} />
      <ToastDialog onToastChange={onToastChange} ref={toastDialogRef} />

      <div
        className={[
          general.height100vh,
          general.respWidth,
          general.overflowScrollY,
          general.appContentsBackground,
          general.hideScrollBar,
        ].join(" ")}
      >
        <div className="w-100 ps-sticky ps-tp row-view pd-10-15 z-i-90 bg-custom-1">
          <div className="col-view">
            <p className="ft-sz-22 cl-white">Referal</p>
            <p className="ft-sz-16 cl-l-white">Refer & Earn</p>
          </div>
        </div>

        <div className='g-v-2 w-100 pd-15 mg-t-10'>
          <div className='col-view'>
            <div>
              <p className='ft-sz-13 cl-white'>Total Members</p>
              <p className='ft-sz-20 cl-white mg-t-5'>{pageConst.totalInvited}</p>
            </div>

            <div className='mg-t-15'>
              <p className='ft-sz-13 cl-white'>Total Income</p>
              <p className='ft-sz-20 cl-white mg-t-5'>₹{pageConst.totalIncome}</p>
            </div>
          </div>

          <div className='col-view a-right'>
            <img className={`h-120-p`} src={require('../media/icons/teamwork_bg.png')} />
          </div>
        </div>

        <div className='col-view pd-15 mg-t-10 mg-b-10em'>
          <div className='col-view w-100 mg-t-20 pd-10 bg-white br-10'>

            <div className='row-view w-100 sb-view'>
              <div className='col-view a-center pd-10'>{getStorage("uid")} | My Code</div>

              <div className='h-w-36 v-center br-50 bg-primary' onClick={() => copyMyId()}>
                <img className='w-15-p' src={require("../media/icons/copy_icon.png")} />
              </div>
            </div>

            <div className='row-view w-100 mg-t-10 sb-view'>
              <div className='col-view a-center pd-10'>{generateReferalURL(getStorage("uid"))}</div>

              <div className='h-w-36 v-center br-50 bg-primary' onClick={() => copyInviteCode()}>
                <img className='w-15-p' src={require("../media/icons/copy_icon.png")} />
              </div>
            </div>

          </div>

          <div className='col-view w-100 mg-t-20 pd-10 bg-white br-10'>

            <div>Rebate Rules</div>
            <div className='ft-sz-13 mg-t-10'>
              The users you invite are called your B-level users & you will receive direct 10% traded commission.
            </div>
            <img className='w-100 mg-t-10' src={require("../media/icons/rebate_rules_icon.png")} />

          </div>

          <div className='col-view w-100 mg-t-20 pd-10 bg-white br-10'>

            <div>Description</div>
            <div className='ft-sz-13 mg-t-10'>
              After team members trade, you can get rebate income
            </div>
            <div className='ft-sz-13 mg-t-10'>Level 1 team: 10%</div>

          </div>

        </div>

        <BottomNavbar activeBar="referal" />
      </div>
    </div>
  );
}

export default Referal;
